import { GameConstants } from "../../GameConstants";
import { GameVars } from "../../GameVars";

export class HeartsContainer extends Phaser.GameObjects.Container {

    // private hearts: Phaser.GameObjects.Image [];
    private hearts: Phaser.GameObjects.Image[];
    private extraHearts: Phaser.GameObjects.Image;

    constructor(scene: Phaser.Scene) {

        super(scene);

        this.x = GameConstants.GAME_WIDTH / 2  - 155 * GameVars.scaleX;
        this.y = 300;

        this.scaleX = GameVars.scaleX;

        let heartsBack = new Phaser.GameObjects.Image(this.scene, 0, 0, "texture_atlas_1", "life_bar_0.png");
        this.add(heartsBack);

        this.hearts = [];

        let heart = new Phaser.GameObjects.Image(this.scene, 0, 39, "texture_atlas_1", "life_heart.png");
        this.add(heart);
        this.hearts.push(heart);

        heart = new Phaser.GameObjects.Image(this.scene, 0, 0, "texture_atlas_1", "life_heart.png");
        this.add(heart);
        this.hearts.push(heart);

        heart = new Phaser.GameObjects.Image(this.scene, 0, -39, "texture_atlas_1", "life_heart.png");
        this.add(heart);
        this.hearts.push(heart);

        this.extraHearts = new Phaser.GameObjects.Image(this.scene, -50, 0, "texture_atlas_1", "streak_0.png");
        this.add(this.extraHearts);

        const streakLabel = new Phaser.GameObjects.Text(this.scene, this.extraHearts.x , 90, "WIN\nSTREAK", {fontFamily: "Oswald-Medium", fontSize: "20px", color: "#25715d", align: "center"});
        streakLabel.setOrigin(.5);
        this.add(streakLabel);  
    }

    public updateHearts(): void {

        for (let i = 0; i < this.hearts.length; i++) {
            if (GameVars.hiLoHearts >= i + 1) {
                if (this.hearts[i].alpha === 0) {
                    this.scene.tweens.add({
                        targets: this.hearts[i],
                        scaleX: 1,
                        scaleY: 1,
                        alpha: 1,
                        ease: Phaser.Math.Easing.Quadratic.In,
                        duration: 250
                    });
                }
            } else if (GameVars.hiLoHearts < i + 1) {
                if (this.hearts[i].alpha > 0) {
                    this.scene.tweens.add({
                        targets: this.hearts[i],
                        scaleX: 1.5,
                        scaleY: 1.5,
                        alpha: 0,
                        ease: Phaser.Math.Easing.Quadratic.In,
                        duration: 250
                    });
                }
            }
        }
    }

    public updateExtraHearts(): void {

        this.extraHearts.setFrame("streak_" + GameVars.hiLoExtraHearts + ".png");
    }
}
